import { Grid, Separator } from '@fs/zion-ui'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import BirthYearPersonTile from './BirthYearPersonTile'

const header = css`
  padding-top: 10px;
  padding-inline-end: 16px;
  padding-bottom: 2px;
  padding-inline-start: 0;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 1px solid #000;
`

export default function GenerationGroup({ generation, onPersonTileClick, inDiscoveryCenter = false }) {
  const [t] = useTranslation()
  return (
    <>
      <div css={header}>{t(generation.nameTranslationKey)}</div>
      <Separator size="sm" />
      <Grid>
        {generation.people.map((person) => {
          return (
            <BirthYearPersonTile
              person={person}
              inDiscoveryCenter={inDiscoveryCenter}
              tileClickHandler={onPersonTileClick}
              key={person.personId}
            />
          )
        })}
      </Grid>
    </>
  )
}

GenerationGroup.propTypes = {
  generation: shape({
    nameTranslationKey: string,
    people: arrayOf(
      shape({
        atn: string,
        displayName: string,
        gender: string,
        genderType: string,
        lifespan: string,
        living: bool,
        name: string,
        personId: string,
        surname: string,
      })
    ),
  }),
  onPersonTileClick: func,
  inDiscoveryCenter: bool,
}
